<template>
    <span>{{display}}</span>
</template>

<script>
    export default {
        name: "date-time-display",
        props: ['date'],
        computed: {
            display : function() {
                if (this.date) {
                    const d = new Date(this.date);
                    return d.toLocaleDateString() + " " + d.toLocaleTimeString();
                } else {
                    return '';
                }

            }
        }
    }
</script>